import React from 'react';
import { EntityAttachmentsSection } from '../../../components/EntityAttachmentsSection';
import { Task } from '../useData';

interface TaskAttachmentsSectionProps {
  taskId: number;
  files: Task['FileAttachment'];
}

export const TaskAttachmentsSection: React.FC<TaskAttachmentsSectionProps> = ({ taskId, files }) => (
  <EntityAttachmentsSection
    downloadEndpoint={`/crm-tasks/tasks/${taskId}/files`}
    files={files || []}
    defaultDownloadName={`task_${taskId}_files.zip`}
    getViewFileUrl={(fileId) => `/crm-tasks/tasks/${taskId}/files/${fileId}`}
  />
);

export default TaskAttachmentsSection;
